module.exports = __webpack_public_path__ + "static/img/Beau-Addinsall.8f27492.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Beau-Addinsall.jpg
// module id = 1DBp
// module chunks = 0